<template>
  <p v-if="pitchType.isByo">
    <template v-if="withTitle">
      <translate
        v-if="unlimitedDimensions"
        :tt="{
          unlimited: pitchType.dimensionsDetailed?.dimensionsType,
        }"
        >Pitch size: {unlimited}</translate
      >
      <translate
        v-else-if="
          customDimensions && pitchType.dimensionsDetailed?.customDimensions
        "
        :tt="{
          customDimensionsText: pitchType.dimensionsDetailed?.customDimensions,
        }"
        >Pitch size: {customDimensionsText}</translate
      >
      <template v-else-if="displayMeasurements">
        <translate
          :tt="{
            MinOrMaxOrAverage: pitchType.dimensionsDetailed?.dimensionsType,
            widthValue: pitchType.dimensionsDetailed?.widthM,
            depthValue: pitchType.dimensionsDetailed?.depthM,
          }"
          >Pitch size: {MinOrMaxOrAverage} {widthValue}m width × {depthValue}m
          depth
        </translate>
      </template>
    </template>
    <!-- no title -->
    <template v-else>
      <template v-if="unlimitedDimensions">
        {{ pitchType.dimensionsDetailed?.dimensionsType }}
      </template>
      <template v-else-if="customDimensions">
        {{ pitchType.dimensionsDetailed?.customDimensions }}
      </template>
      <template v-else-if="displayMeasurements">
        <translate
          :tt="{
            MinOrMaxOrAverage: pitchType.dimensionsDetailed?.dimensionsType,
            widthValue: pitchType.dimensionsDetailed?.widthM,
            depthValue: pitchType.dimensionsDetailed?.depthM,
          }"
          >{MinOrMaxOrAverage} {widthValue}m width × {depthValue}m depth
        </translate>
      </template>
    </template>
    <template v-if="displayMeasurements && pitchType.dimensionsDetailed?.areaM"
      >({{ pitchType.dimensionsDetailed?.areaM }}m²)
    </template>
  </p>
  <!-- Non-BYO -->
  <p v-else>
    <template v-if="localeIsEn">
      <translate
        v-if="
          withTitle &&
          pitchType.dimensionsDetailed?.widthFt &&
          pitchType.dimensionsDetailed?.depthFt
        "
        :tt="{
          MinOrMaxOrAverage: pitchType.dimensionsDetailed?.dimensionsType,
          widthValue: pitchType.dimensionsDetailed?.widthFt,
          lengthValue: pitchType.dimensionsDetailed?.depthFt,
        }"
        >Dimensions: {MinOrMaxOrAverage} {widthValue}ft width × {lengthValue}ft
        length</translate
      >
      <translate
        v-else-if="
          pitchType.dimensionsDetailed?.widthFt &&
          pitchType.dimensionsDetailed?.depthFt
        "
        :tt="{
          MinOrMaxOrAverage: pitchType.dimensionsDetailed?.dimensionsType,
          widthValue: pitchType.dimensionsDetailed?.widthFt,
          lengthValue: pitchType.dimensionsDetailed?.depthFt,
        }"
        >{MinOrMaxOrAverage} {widthValue}ft width × {lengthValue}ft
        length</translate
      >
    </template>
    <template v-else>
      <!-- NON-EN -->
      <translate
        v-if="
          withTitle &&
          pitchType.dimensionsDetailed?.widthM &&
          pitchType.dimensionsDetailed?.depthM
        "
        :tt="{
          MinOrMaxOrAverage: pitchType.dimensionsDetailed?.dimensionsType,
          widthValue: pitchType.dimensionsDetailed?.widthM,
          lengthValue: pitchType.dimensionsDetailed?.depthM,
        }"
        >Dimensions: {MinOrMaxOrAverage} {widthValue}m width × {lengthValue}m
        length
      </translate>
      <translate
        v-else-if="
          pitchType.dimensionsDetailed?.widthM &&
          pitchType.dimensionsDetailed?.depthM
        "
        :tt="{
          MinOrMaxOrAverage: pitchType.dimensionsDetailed?.dimensionsType,
          widthValue: pitchType.dimensionsDetailed?.widthM,
          lengthValue: pitchType.dimensionsDetailed?.depthM,
        }"
        >{MinOrMaxOrAverage} {widthValue}m width × {lengthValue}m length
      </translate>
    </template>

    <template v-if="!localeIsEn && pitchType.dimensionsDetailed?.areaM"
      >({{ pitchType.dimensionsDetailed?.areaM }}m²)
    </template>
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { PitchType } from '../../types'

const props = withDefaults(
  defineProps<{
    pitchType: PitchType
    withTitle?: boolean
  }>(),
  {
    withTitle: true,
  },
)

const { i18n } = useI18n()
const currentLocale = i18n.locale
const localeIsEn = computed(() => currentLocale.startsWith('en-'))

const displayMeasurements = computed(() => {
  return (
    props.pitchType.dimensionsDetailed?.dimensionsTypeCode === 'avg' ||
    props.pitchType.dimensionsDetailed?.dimensionsTypeCode === 'min' ||
    props.pitchType.dimensionsDetailed?.dimensionsTypeCode === 'max'
  )
})

const customDimensions = computed(() => {
  return props.pitchType.dimensionsDetailed?.dimensionsTypeCode === 'custom'
})

const unlimitedDimensions = computed(() => {
  return props.pitchType.dimensionsDetailed?.dimensionsTypeCode === 'unlimited'
})
</script>
